module.exports = __webpack_public_path__ + "static/media/marriage-3.8c0c53de.jpg";